import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
@import url('https://fonts.googleapis.com/css?family=Roboto');
@font-face {
  font-family: Montserrat;
  src:  url(${process.env.PUBLIC_URL}/fonts/Montserrat-Regular.otf) format('opentype');
  font-weight: regular;

}

@font-face {
  font-family: Montserrat-Light;
  src:  url(${process.env.PUBLIC_URL}/fonts/Montserrat-Light.otf) format('opentype');
  font-weight: light
}

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Montserrat';
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Montserrat';
  }

  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

//bad pracgtise 
.react-autosuggest__container {
  position: relative;
}

.react-autosuggest__input {
  width: 240px;
  height: 30px;
  padding: 10px 20px;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border: 1px solid #aaa;
  border-radius: 4px;
}

.react-autosuggest__input:focus {
  outline: none;
}

.react-autosuggest__container--open .react-autosuggest__input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
  display: none;
}

.react-autosuggest__container--open .react-autosuggest__suggestions-container {
  display: block;
  position: absolute;
  top: 51px;
  width: 280px;
  border: 1px solid #aaa;
  background-color: #fff;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 2;
}

.react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.react-autosuggest__suggestion {
  cursor: pointer;
  padding: 10px 20px;
}

.react-autosuggest__suggestion:not(:first-child) {
  border-top: 1px solid #ddd;
}

.react-autosuggest__suggestion--focused {
  background-color: #0C7EAF;
  color: #fff;
}

.suggestion-content {
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
}

.dancounsell {
  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/dancounsell/48.jpg);
}

.ladylexy {
  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/ladylexy/48.jpg);
}

.mtnmissy {
  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/mtnmissy/48.jpg);
}

.steveodom {
  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/steveodom/48.jpg);
}

.name {
  margin-left: 68px;
  line-height: 45px;
}

.highlight {
  color: #ee0000;
  font-weight: bold;
}

.react-autosuggest__suggestion--focused .highlight {
  color: #120000;
}

//bad 2
@import url(https://fonts.googleapis.com/css?family=Lato:400,300);

// $color-border: #CDCDCD;
// $color-label: darken($color-border, 20%);
// $color-primary: #1695A3;

.field {
  display: block;
  margin-bottom: 0.5rem;
}
label {
  display: block;
  font-size: 0.8rem;
  line-height: 1.4rem;
  font-weight: 600;
  color: darken(#CDCDCD, 20%);
}

input:not([type="radio"]):not([type="checkbox"]), textarea {
  appearance: none;
  border: 1px solid #CDCDCD;
  font-size: 1rem;
  padding: 0.5rem;
  min-width: 10rem;
  
  &:focus {
    outline: 2px solid #1695A3;
  }
}

input[type="radio"], input[type="checkbox"] {
  margin-right: 0.5rem;
}

 button {
   display: block;
   appearance: none;
//   padding: 1rem 2rem;
   text-transform: uppercase;
//   font-size: 0.8rem;
//   // background: #1695A3;
//   color: white;
   border: none;
//   border-radius: 3px;
//   margin: 0.5rem 0;
  
   &:hover {
     opacity: 0.8;
   }
  
//   + button {
//     margin-left: 1rem;
//   }
  
   &.secondary {
     color: #1695A3;
     background: transparent;
     border: 1px solid #1695A3;
   }
 }

 button:focus {outline:0;}


*, *:before, *:after {
  box-sizing: border-box;
  position: relative;
}

body {
  font-family: Lato, Helvetica, sans-serif;
  // padding: 1rem;
}

body, html {
  font-size: 16px;
  height: 100%;
  width: 100%;
  margin: 0;
}

img {
  max-width: 100%;
  font-style: italic;
  vertical-align: middle;
}

//header dropdown menu
.accDropDown{

  // height: 187px;
  width: 177px;
  background-color: rgba(35, 31, 32, 1);
  box-shadow: 0px 2px 7px 0px rgba(123, 123, 123, 0.34);
}

.accDropDownMenuItem {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 300;
    color: rgba(255, 255, 255, 1);
  text-align: center;
  letter-spacing: 0.09em;
}
//end of header dropdown menu

.StripeElement {
  display: block;
  margin: 10px 0 20px 0;
  max-width: 500px;
  padding: 10px 14px;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border-radius: 4px;
  background: white;
}

.StripeElement--focus {
  box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
}

.StripeElement.PaymentRequestButton {
  padding: 0;
}

`;



// WEBPACK FOOTER //
// ./src/global-styles.js